import { useState } from "@erp/shared/composables/useState";
import { defineStore } from "pinia";
export const usePurchaseIsCommercialStore = defineStore("is-purchase-commercial", () => {
    const [isCommercial, setIsCommercial] = useState(true);
    return { isCommercial, setIsCommercial };
});
